class Pagination<Results> {
  currentPage: number;

  elementsByPage: number;

  totalElements: number;

  totalPages: number;

  onGetPage: (start: number, end: number) => Promise<Results>;

  constructor(
    startIndexElement: number,
    elementsByPage: number,
    totalElements: number,
    onGetPage: Pagination<Results>['onGetPage']
  ) {
    this.currentPage = Math.floor(startIndexElement / elementsByPage) + 1;
    this.elementsByPage = elementsByPage;
    this.totalElements = totalElements;
    this.totalPages = Math.ceil(totalElements / elementsByPage);
    this.onGetPage = onGetPage;
  }

  previous(): Promise<Results> {
    return this.getPage(this.currentPage - 1);
  }

  next(): Promise<Results> {
    return this.getPage(this.currentPage + 1);
  }

  getPage(pageNumber: number): Promise<Results> {
    if (pageNumber < 1 || pageNumber > this.totalPages) {
      throw new RangeError(
        `Pagination::getPage: try to get page ${pageNumber} while minimum is 1 and maximum is ${this.totalPages}.`
      );
    }

    const start = this.elementsByPage * (pageNumber - 1);
    const end = start + this.elementsByPage - 1;

    this.currentPage = pageNumber;

    return this.onGetPage(start, end);
  }

  isOnLastPage(): boolean {
    return this.currentPage === this.totalPages;
  }

  isOnFirstPage(): boolean {
    return this.currentPage === 1;
  }

  serialize(): {
    currentPage: number;
    elementsByPage: number;
    totalElements: number;
    totalPages: number;
  } {
    const { currentPage, elementsByPage, totalElements, totalPages } = this;

    return {
      currentPage,
      elementsByPage,
      totalElements,
      totalPages,
    };
  }
}

export default Pagination;
